export function DocBlocks({ blocks, emptyText = "Entered at registration", compact = false, placeholderText }) {
  const pCls = compact ? "mt-3 text-sm font-medium text-white/60 leading-relaxed" : "mt-4 text-base font-medium text-white/60 leading-relaxed";
  const hCls = compact ? "mt-6 text-sm font-extrabold uppercase tracking-wide text-white" : "mt-10 text-xl md:text-2xl font-extrabold tracking-tight text-white";
  return (
    <>
      {(blocks || []).map((b, i) => {
        if (b.type === "h") {
          const sec = (b.text.match(/^(\d+)\./) || [])[1];
          return <h2 key={i} id={sec ? `section-${sec}` : undefined} className={`${hCls} scroll-mt-24`}>{b.text}</h2>;
        }
        if (b.type === "list")
          return (
            <ul key={i} className="mt-4 space-y-2.5 pl-1">
              {b.items.map((it, j) => (
                <li key={j} className="flex gap-3 text-base font-medium text-white/60 leading-relaxed">
                  <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#2563EB]" /><span>{it}</span>
                </li>
              ))}
            </ul>
          );
        if (b.type === "field") {
          const val = b.value !== undefined ? b.value : null;
          return (
            <div key={i} data-testid={b.key ? `agreement-field-${b.key}` : undefined} className="mt-2 grid grid-cols-1 sm:grid-cols-5 gap-1 sm:gap-4 border-b border-white/10 py-2.5">
              <p className="sm:col-span-2 text-xs font-bold uppercase tracking-wider text-white/40">{b.label}</p>
              {val === null
                ? <p className="sm:col-span-3 text-sm font-semibold text-white/40 italic">{placeholderText || b.placeholder}</p>
                : val
                ? <p className={`sm:col-span-3 text-sm font-semibold ${b.sample ? "text-amber-300 italic" : "text-white"}`}>{val}</p>
                : <p className="sm:col-span-3 text-sm font-semibold text-white/35 italic">{emptyText}</p>}
            </div>
          );
        }
        return <p key={i} className={pCls}>{b.text}</p>;
      })}
    </>
  );
}
